import React                        from 'react';
import PropTypes                    from 'prop-types'
import classnames                   from 'classnames';
import { useSelector, useDispatch } from 'react-redux'
import { START }                    from 'pu-data/QuoteSteps';

import BundleItemWrap    from 'pu-react/components/BundleItemWrap';
import ProvidePart       from './ProvidePart'
import Parameters        from './Parameters';
import ParametersSummary from './ParametersSummary';
import BomRequirements   from './BomRequirements';
import Prices            from './Prices';

import BomTool             from '../bom/BomTool';

import {
  getReport,
} from 'pu-utils/BomActions';

import {
  changeParameter, priceSelected, allowEdit, deleteQuote, supplyParts,
  uploadBomFile, quoteBom, saveBom, closeBomSection, changeBomParameter,
  changeNumBoard, updatePartStatus, changeMountingType, findSubstitutePart,
  selectSubstitutePart, closeSubstitutePart, searchPart, selectSubstitutePartFailure,
  showPartByFilter, saveSubstitutePart, saveSubstitutePartFailure,
} from '../data/PartsSlice'

import { changeParameter as changeAssemblyParameter }  from '../../pcb-assembly/data/AssemblySlice';

/**
 *
 * @param itemId id of bundle items, used when the projects is populate
 * @returns {JSX.Element}
 * @constructor
 */
const Parts = ({ itemId }) => {
  const dispatch = useDispatch();

  const assemblyState = useSelector((state) => state.assembly);
  const {
    name,
    code,
    provideParts,
    parameters,
    quote,
    workbook,
    bomParameters,
    bomId,
    bomQuoteNumber,
    bomStep,
    loading,
    price,
    itemSelected,
    selectedQuantity,
    errors,
    showModal,
    showSummary,
    quoteStep,
    focusOfferID,
    substituteParts,
    filter,
    possibleOption,
    possibleSustitutes,
  } = useSelector((state) => state.parts)

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }))
  }

  const onChangeBomParameter = (name, value) => {
    dispatch(changeBomParameter({ name, value }))
  }

  const onSupplyParts = (value) => {
    dispatch(supplyParts(value))
  }

  const onPriceSelect = (data) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(priceSelected(data, authToken, bomQuoteNumber))
  }

  const onUploadBomFile = (file) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(uploadBomFile(file, authToken))
  }

  const onQuoteBom =(data) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    dispatch(quoteBom(itemId, bomId, bomParameters, authToken));
  }

  const onSaveBom = () => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    var quantity = selectedQuantity
    if (quantity === null){
      quantity = parseInt(quote.quantities[0])
    }
    const {report, errors } = getReport(quote, quantity)
    if (Object.keys(errors).length == 0){
      var assembly_parameters = report['assembly_parameters']

      /* Check the Assembly Services haven't been quoted yet.
         Validate the Quote Step of this component. */
      if (assemblyState.quoteStep == 'START'){
        Object.entries(assembly_parameters).forEach(([name, value]) => {
          if(value &&  value != 0){
            dispatch(changeAssemblyParameter({ name, value: String(value) }))
          }else{
            dispatch(changeAssemblyParameter({ name, value: String(0) }))
          }
        });
      }

      dispatch(saveBom(bomQuoteNumber, quantity, quote, report, authToken));
    }else {
      // MANAGE ERRORS SAVEBOM FAILURE
    }
  }

  const onCloseBomSection = () => {
    dispatch(closeBomSection())
  }

  const onChangePartAction = (offer_id, value, quantity) => {
    dispatch(updatePartStatus(quote, offer_id, value, quantity))
  }

  const onFindSubstitutePart = (offer_id, quantity) => {
    dispatch(findSubstitutePart({offer_id, quantity}))
  }

  const onChangeMountingType = (offer_id, value) => {
    dispatch(changeMountingType({offer_id, value}))
  }

  const onChangeNumBoard = (quantity) => {
    dispatch(changeNumBoard(quantity))
  }

  const onSearchPart = (part) => {
    dispatch(searchPart(part))
  }

  const onShowPartByStatus = (status) => {
    dispatch(showPartByFilter(status))
  }

  const onSelectSubstitutePart = (is_check, offer_id, substitute_id, substitute, selected_quantity, type, option_id=null, qty=null) => {
    dispatch(selectSubstitutePart({is_check,
                                   offer_id,
                                   substitute_id,
                                   substitute,
                                   selected_quantity,
                                   type, 
                                   option_id, 
                                   qty
                                  }))
  }

  const onSaveSubstitutePart = () => {
    if (possibleOption.length == 0 && possibleSustitutes.length == 0){
      dispatch(saveSubstitutePartFailure({message: "Please select an option to replace."}))
    }else{
      if (possibleOption.length > 0 && possibleSustitutes.length > 0){
        dispatch(saveSubstitutePartFailure({message: "You only can check a subsitute or a similirar part. No both."}))
      }else{
        const offer = quote.offers[focusOfferID]
        const qty_needed = offer.qty_per_board * selectedQuantity

        if(possibleOption.length > 1){
          dispatch(saveSubstitutePartFailure({message: "You only can check one similirar part."}))
        }else{
          if(possibleOption.length != 0){
            const option = possibleOption[0]
            if (option.stock[selectedQuantity] < qty_needed){
              dispatch(saveSubstitutePartFailure({message: "The part that you want to subsitute don't have enough stock."}))
            }else{
              dispatch(saveSubstitutePart("other"))
            }
          }
        }

        if(possibleSustitutes.length > 1){
          dispatch(saveSubstitutePartFailure({message: "You only can check one subsitute part."}))
        }else{
          if(possibleSustitutes.length != 0){
            const substitute = possibleSustitutes[0]
            
            var stock = 0;
            substitute.vendor_options.forEach(function (option, i) {
              if (option.check !== undefined && option.check){
                stock = stock + option.stock;
              }
            })

            if (stock < qty_needed){
              dispatch(saveSubstitutePartFailure({message: "Your selection don't have enough stock."}))
            }else{
              dispatch(saveSubstitutePart("substitute"))
            }
          }
        }
      }
        // const offer = quote.offers[focusOfferID]
    }
    // const 
    // possibleOption: [],
    // possibleSustitutes: [],
    // const offer = quote.offers[offer_id]
    // const qty_needed = offer.qty_per_board * selected_quantity
    // if (substitute.stock < qty_needed){
    //   dispatch(saveSubstitutePartFailure())
    // }else{
    //   dispatch(saveSubstitutePart())
    // }
    // selected_quantity = {selectedQuantity}
    // focus_offer_id = {focusOfferID}

    // dispatch(saveSubstitutePart())
  }

  const onCloseSubstitutePart = () => {
    dispatch(closeSubstitutePart())
  }

  const showEdit = quoteStep !== START && showSummary
  const showDelete = quoteStep !== START && (!!quote || !!quote.totals)

  const classFormSection = classnames('form-content', { 'd-none': provideParts });

  return (
    <BundleItemWrap
      name={name}
      showEdit={showEdit}
      showDelete={showDelete}
      onEdit={() => dispatch(allowEdit())}
      onDelete={() => dispatch(deleteQuote())}
      contentClassName={{summary: showSummary}}>
      <div className="pcb-parts-section">
        <div className="pcb-parts-form-section">
          <ProvidePart
            provideParts={provideParts}
            onSupplyParts={onSupplyParts} />
          <div className={classFormSection}>
            <div className="row">
              <div className="col-lg-5">
                <Parameters
                  itemId={itemId}
                  bomQuoteNumber={bomQuoteNumber}
                  selectedQuantity = {selectedQuantity}
                  price = {price}
                  parameters={parameters}
                  itemSelected={itemSelected}
                  onChangeParameter={onChangeParameter}
                  onUploadBomFile={onUploadBomFile}
                  showSummary={showSummary}
                  loading={loading}
                  errors={errors} />
                <div className="summary-section">
                  <ParametersSummary
                    quote={quote}
                    selectedQuantity = {selectedQuantity}
                    showSummary={showSummary} />
                </div>
              </div>
              <div className="col-lg-7">
                <BomRequirements showSummary={showSummary} />
                <Prices
                  itemId={itemId}
                  selected_quantity = {selectedQuantity}
                  quote={quote}
                  parameters={parameters}
                  showSummary={showSummary}
                  parametersChanged={false}
                  onPriceSelect={onPriceSelect} />
              </div>
            </div>
          </div>
        </div>

        <BomTool
          itemId={itemId}
          bomParameters={bomParameters}
          workbook={workbook}
          quote={quote}
          loading={loading}
          show_modal={showModal}
          bom_id={bomId}
          bom_quote_number={bomQuoteNumber}
          step={bomStep}
          selected_quantity = {selectedQuantity}
          focus_offer_id = {focusOfferID}
          substitute_parts = {substituteParts}
          filter = {filter}
          onShowPartByStatus = {onShowPartByStatus}
          onChangeBomParameter = {onChangeBomParameter}
          onChangeNumBoard = {onChangeNumBoard}
          onChangePartAction = {onChangePartAction}
          onChangeMountingType = {onChangeMountingType}
          onFindSubstitutePart = {onFindSubstitutePart}
          onSearchPart={onSearchPart}
          onSelectSubstitutePart={onSelectSubstitutePart}
          onSaveSubstitutePart={onSaveSubstitutePart}
          onCloseSubstitutePart={onCloseSubstitutePart}
          onPriceSelect = {onPriceSelect}
          onQuoteBom ={onQuoteBom}
          onSaveBom = {onSaveBom}
          onCloseBomSection = {onCloseBomSection}
          errors={errors} />
      </div>
    </BundleItemWrap>
  );
};

Parts.propTypes = {
  itemId: PropTypes.number.isRequired,
}

export default Parts;
